import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Divider, message, Popconfirm, Table, Tooltip } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarAlt, faEdit, faLockOpen, faTrash } from '@fortawesome/free-solid-svg-icons'

import EditUserModal from './EditUserModal'
import { deleteUser } from '../services'
import { handleError } from '../../../helpers'
import UserScheduleModal from '../../UserSchedules/partials/UserScheduleModal'
import UserStoresModal from './UserStoresModal'

export default function UsersTable({ users, reload }) {
	const currentUser = useSelector(state => state.auth.user)
	const [editUser, setEditUser] = useState(null)
	const [scheduleModalUser, setScheduleModalUser] = useState(null)
	const [userStoresModal, setUserStoresModal] = useState(null)

	const handleDelete = id => {
		deleteUser(id)
			.then(() => {
				message.success('Usuario Eliminado Exitosamente')
				reload()
			})
			.catch(error => handleError(error))
	}

	const columns = [
		{
			title: 'Nombre Completo',
			dataIndex: 'name'
		},
		{
			title: 'Documento',
			dataIndex: 'document'
		},
		{
			title: 'Cargo',
			dataIndex: 'ranking_name'
		},
		{
			title: 'Estado',
			dataIndex: 'active',
			render: t => t === 1 ? 'Activo' : 'Inactivo'
		},
		{
			title: 'Acciones',
			render: (t, record) => (
				<React.Fragment>
					<Tooltip title="Editar Usuario">
						<FontAwesomeIcon className="text-link" icon={faEdit} onClick={()=>setEditUser(record)} />
					</Tooltip>
					<Divider type="vertical" />
					<Tooltip title="Horario">
						<FontAwesomeIcon className="text-link" icon={faCalendarAlt} onClick={()=>setScheduleModalUser(record)} />
					</Tooltip>
					<Divider type="vertical" />
					<Tooltip title="Tiendas Asociadas">
						<FontAwesomeIcon className="text-link" icon={faLockOpen} onClick={()=>setUserStoresModal(record.id)} />
					</Tooltip>
					{ record.id !== currentUser.id && currentUser.ranking === 'admin' && (
						<React.Fragment>
							<Divider type="vertical" />
							<Popconfirm 
								title="¿Desea eliminar el usuario?"
								okText="Eliminar"
								cancelText="Cancelar"
								onConfirm={() => handleDelete(record.id)}
								okButtonProps={{ danger:true }}
							>
								<FontAwesomeIcon className="text-link" icon={faTrash} />
							</Popconfirm>
						</React.Fragment>
					)}
				</React.Fragment>
			)
		}
	]

	return (
		<React.Fragment>
			<Table 
				dataSource={users}
				columns={columns}
				rowKey={record => record.id}
			/>
			{ editUser && (
				<EditUserModal 
					visible={true}
					onClose={()=>setEditUser(null)}
					user={editUser}
					reload={reload}
				/>
			)}
			{ scheduleModalUser && (
				<UserScheduleModal 
					visible
					onClose={() => setScheduleModalUser(null)}
					userId={scheduleModalUser.id}
				/>
			)}
			{ userStoresModal && (
				<UserStoresModal 
					visible
					onClose={() => setUserStoresModal(null)}
					userId={userStoresModal}
				/>
			)}
		</React.Fragment>
	)
}